import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const calculateNextHighestZ = (currentZ: CSSProperties['zIndex']) =>
  !currentZ || typeof currentZ === 'string' ? 1 : currentZ + 1;
